// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__FR5pd","logout":"Dashboard_logout__DXC7w","dashboard__wrap":"Dashboard_dashboard__wrap__wVleE"};